import type { ReactNode } from "react";
import { useSearchParams } from "react-router";
import { WayflyerError } from "shared-ui";

import { UploadDocumentType } from "../../../types";

import { VerifyBalanceSheetPage } from "./verify-balance-sheet-page";
import { VerifyProfitAndLossPage } from "./verify-profit-and-loss-page";

const VerifyDocumentsByType: Partial<Record<UploadDocumentType, ReactNode>> = {
  [UploadDocumentType.PROFIT_AND_LOSS]: <VerifyProfitAndLossPage />,
  [UploadDocumentType.BALANCE_SHEET]: <VerifyBalanceSheetPage />,
};

export const VerifyDocumentUploadsManager = () => {
  const [searchParams] = useSearchParams();
  const document = searchParams.get("document");

  if (!document || !(document in VerifyDocumentsByType)) {
    throw new WayflyerError("Missing or unknown document type", "404");
  }

  return VerifyDocumentsByType[document as UploadDocumentType];
};
